function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { isFunction, uniqueString } from '@bydesign-ui/utils';
import { CascaderCore, CascaderState } from './CascaderCore';
export var Cascader = function (_CascaderCore) {
  _inherits(Cascader, _CascaderCore);

  var _super = _createSuper(Cascader);

  function Cascader() {
    var _this;

    _classCallCheck(this, Cascader);

    _this = _super.apply(this, arguments);
    _this.treeSearchMatchNodes = null;
    _this.columnWidth = 200;
    _this.expandedIds = [];
    _this.inited = false;
    _this.dragId = '';
    _this.drapMousePos = {
      x: 0,
      y: 0
    };
    _this.enterID = '';
    return _this;
  }

  _createClass(Cascader, [{
    key: "updateCascader",
    value: function updateCascader(options) {
      var _this2 = this;

      this.columnWidth = options.columnWidth == null ? 200 : options.columnWidth;

      var _this$updateCascaderO = this.updateCascaderOptions(options),
          needUpdateValue = _this$updateCascaderO.needUpdateValue,
          needUpdateDatasource = _this$updateCascaderO.needUpdateDatasource,
          prevValueHash = _this$updateCascaderO.prevValueHash;

      var currentIds = Object.keys(this.hashMap);

      if (needUpdateDatasource) {
        this.expandedIds = this.expandedIds.filter(function (i) {
          var _a;

          return currentIds.includes(i) || currentIds.includes(prevValueHash[String((_a = _this2.hashMap[i]) === null || _a === void 0 ? void 0 : _a.value)]);
        });
      }

      if (options.expandedIds !== undefined) {
        this.expandedIds = this.getExpandedIdsByValue(options.expandedIds);
      } else if (!this.inited && options.defaultExpandedIds !== undefined) {
        this.expandedIds = this.getExpandedIdsByValue(options.defaultExpandedIds);
      }

      if (needUpdateValue && this.selectToExpand) {
        this.setExpandedBySetValue(this.value);
      }

      this.inited = true;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(Cascader.prototype), "dispose", this).call(this);

      this.expandedIds = [];
      this.inited = false;
      this.removeAllListeners('expanded-change');
      this.removeAllListeners('expanded');
      this.removeAllListeners('drop');
    }
  }, {
    key: "getColumnTitle",
    value: function getColumnTitle(idx, parentId) {
      if (isFunction(this.columnTitles)) {
        var info = this.getItemInfo(parentId);
        return this.columnTitles(info);
      } else if (this.columnTitles.length === 0) {
        return null;
      }

      return this.columnTitles[idx];
    }
  }, {
    key: "getExpandedIdsByValue",
    value: function getExpandedIdsByValue(value) {
      var _this3 = this;

      var ids = this.getIdsByValues(value);
      var expandedIds = ids.slice(0);
      ids.forEach(function (id) {
        var node = _this3.getItemInfo(id);

        node.nodePath.forEach(function (expandedId) {
          if (expandedIds.indexOf(expandedId) === -1) {
            expandedIds.push(expandedId);
          }
        });
      });
      return expandedIds;
    }
  }, {
    key: "dragStart",
    value: function dragStart(id) {
      this.dragId = id;
    }
  }, {
    key: "getDragId",
    value: function getDragId() {
      return this.dragId;
    }
  }, {
    key: "drapMouse",
    value: function drapMouse(x, y) {
      this.drapMousePos = {
        x: x,
        y: y
      };
    }
  }, {
    key: "drop",
    value: function drop(id, dropIndex, dropToGap) {
      this.emit('drop', {
        node: this.getItemInfo(id),
        dragNode: this.getItemInfo(this.dragId),
        dropIndex: dropIndex,
        dropToGap: dropToGap
      });
    }
  }, {
    key: "setItemRef",
    value: function setItemRef(id, ref) {
      this.hashMap[id].ref = ref;
    }
  }, {
    key: "setEnterID",
    value: function setEnterID(id) {
      this.enterID = id;
    }
  }, {
    key: "getEnterID",
    value: function getEnterID() {
      return this.enterID;
    }
  }, {
    key: "setExpanded",
    value: function setExpanded(id) {
      var _this4 = this;

      var expanded = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var info = this.getItemInfo(id);
      var idx = this.expandedIds.indexOf(id);

      if (this.accordion) {
        if (expanded) {
          this.expandedIds = info.nodePath.slice(0);
        } else if (!expanded) {
          this.expandedIds = idx > -1 ? this.expandedIds.slice(0, idx) : [];
        }
      } else {
        if (expanded) {
          info.nodePath.forEach(function (expandedId) {
            if (_this4.expandedIds.indexOf(expandedId) === -1) {
              _this4.expandedIds.push(expandedId);
            }
          });
        } else {
          var descendants = this.getDescendants(id);
          var ids = descendants.concat(id);
          this.expandedIds = this.expandedIds.splice(0).filter(function (expandedId) {
            return ids.indexOf(expandedId) === -1;
          });
        }
      }

      if (info.needLoad) {
        info.needLoad = false;
        info.loading = true;
        this.emit('item-loading', id);
        this.load(info).then(function (datasource) {
          info.loading = false;
          info.children = datasource.map(function (item) {
            return _this4.createDataHashMap(item, info.id, info.level + 1);
          });
          info.isLeaf = info.children.length <= 0;

          if (!info.isLeaf && info.state === CascaderState.SELECTED) {
            info.state = CascaderState.UNSELECTED;

            _this4.updateSelectedState(id, CascaderState.SELECTED);

            if (_this4.spread) {
              _this4.emit('value-change');

              _this4.emit('change', _this4.value = _this4.getValueFromSelected());
            }
          }

          _this4.emit('item-loading', id);
        }).catch(function (e) {
          console.error(e);
          info.loading = false;
          info.children = [];
          info.isLeaf = true;

          _this4.emit('item-loading', id);
        });
      }

      this.emit('expanded-change');
      this.emit('expanded', this.getValueFromExpanded());
    }
  }, {
    key: "getValueFromExpanded",
    value: function getValueFromExpanded() {
      var _this5 = this;

      var withLeaf = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var value = [];
      this.expandedIds.forEach(function (id) {
        var node = _this5.hashMap[id];

        if (node.level === 0) {
          return;
        }

        if (withLeaf || !withLeaf && !node.isLeaf) {
          value.push(node.value);
        }
      });
      return value;
    }
  }, {
    key: "getFromSelectedValue",
    value: function getFromSelectedValue() {
      return this.getValueFromSelected();
    }
  }, {
    key: "getSelectToExpand",
    value: function getSelectToExpand() {
      return this.selectToExpand;
    }
  }, {
    key: "getExpandedIds",
    value: function getExpandedIds() {
      if (this.expandedIds.length > 0) {
        return this.expandedIds;
      }

      return this.hashMap[this.root].isLeaf ? [] : [this.root];
    }
  }, {
    key: "getExpandedItemIds",
    value: function getExpandedItemIds() {
      var _this6 = this;

      var root = this.getItemInfo(this.getRootId());
      var ids = [];

      var fn = function fn(list) {
        list.forEach(function (item) {
          if (_this6.isItemExpended(item.id)) {
            ids.push(item.id);
          }

          fn(item.children);
        });
      };

      fn(root.children);
      return ids;
    }
  }, {
    key: "setItemState",
    value: function setItemState(id, newState, expanded) {
      var _this7 = this;

      if (this.hashMap[id].disabled || this.hashMap[id].readonly) {
        return;
      }

      this.emit('try-set-item-state');

      _get(_getPrototypeOf(Cascader.prototype), "setItemState", this).call(this, id, newState);

      if (!this.multiple && this.clickToExpand && expanded !== undefined) {
        this.setExpanded(id, expanded);
        return;
      }

      if (this.selectToExpand === false) {
        return;
      }

      if (this.multiple) {
        var state = this.hashMap[id].state;

        if (state === CascaderState.SELECTED) {
          if (this.expandedIds.length === 0) {
            this.setExpanded(id);
            return;
          }

          this.expandedIds.every(function (expandedId) {
            var expandedNode = _this7.hashMap[expandedId];

            if (expandedNode.nodePath.indexOf(id) < 0) {
              _this7.setExpanded(id);

              return false;
            }

            return true;
          });
        }
      } else {
        this.setExpanded(id);
      }
    }
  }, {
    key: "resetValue",
    value: function resetValue() {
      this.emit('change', []);
    }
  }, {
    key: "setTreeSearch",
    value: function setTreeSearch(query) {
      var _this8 = this;

      var filterTreeNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.defaultFilter;
      var expandedIds = [];
      this.treeSearchMatchNodes = [];

      if (query) {
        Object.keys(this.hashMap).forEach(function (id) {
          var map = _this8.hashMap[id];

          if (filterTreeNode(query, map) && _this8.treeSearchMatchNodes) {
            _this8.treeSearchMatchNodes = _this8.treeSearchMatchNodes.concat(map.nodePath);
            expandedIds = expandedIds.concat(map.nodePath.slice(0, -1));
          }
        });
      } else {
        this.treeSearchMatchNodes = null;
      }

      this.expandedIds = uniqueString(expandedIds);
      this.emit('expanded-change');
    }
  }, {
    key: "matchTreeSearch",
    value: function matchTreeSearch(id) {
      if (this.treeSearchMatchNodes === null) {
        return true;
      }

      return this.treeSearchMatchNodes.indexOf(id) > -1;
    }
  }, {
    key: "defaultFilter",
    value: function defaultFilter(searchValue, node) {
      return node.label.indexOf(searchValue) > -1;
    }
  }, {
    key: "setExpandedBySetValue",
    value: function setExpandedBySetValue(value) {
      if (!value.length) {
        this.expandedIds = [];
        this.emit('expanded-change');
        return true;
      }

      var hashMapKeys = Object.keys(this.hashMap);
      this.expandedIds = this.expandedIds.filter(function (expandedId) {
        return hashMapKeys.indexOf(expandedId) > -1;
      });

      if (this.expandedIds.length === 0) {
        var id = this.getIdByValue(value[value.length - 1]);
        this.setExpanded(id);
        return true;
      }

      return false;
    }
  }, {
    key: "isItemExpended",
    value: function isItemExpended(id) {
      var _this9 = this;

      var item = this.getItemInfo(id);
      var expandIds = this.expandedIds;

      if (item.level === 1) {
        return true;
      }

      return expandIds.some(function (key) {
        return _this9.getItemInfo(key).nodePath.indexOf(id) >= 0;
      });
    }
  }]);

  return Cascader;
}(CascaderCore);